export default [
    { // Pantalla 1
        path: '/controlAsc/lotes/asc', // Url Path
        name: 'control-asc-lotes-asc', // Route name
        component: () => import('@/views/pages/controlAsc/VistaLotesAsc.vue'),
        meta: {
			title: 'i18n:Lotes ASC',
            resource: 'Control ASC',
            action: 'ver-control-asc-lotes',
            pageTitle: 'Control Lotes ASC',
            breadcrumb: [
                {
                    text: 'Control ASC',
                    active: true,
                },
                {
                    text: 'Lotes',
                },
            ],
        },
    },
    { // Pantalla 2
        path: '/controlAsc/ingresos', // Url Path
        name: 'control-asc-lotes-ingresos', // Route name
        component: () => import('@/views/pages/controlAsc/VistaIngresosAsc.vue'),
        meta: {
			title: 'i18n:Control de Movimientos',
            resource: 'Control ASC',
            action: 'ver-control-asc-lotes-ingresos',
            pageTitle: 'Control Lotes ASC',
            breadcrumb: [
                {
                    text: 'Control ASC',
                    active: true,
                },
                {
                    text: 'Movimientos',
                    active: true,
                },
                {
                    text: 'Ingresos',
                },
            ],
        },
    },
    { // Pantalla 3
        path: '/controlAsc/egresos', // Url Path
        name: 'control-asc-lotes-egresos', // Route name
        component: () => import('@/views/pages/controlAsc/VistaEgresosAsc.vue'),
        meta: {
			title: 'i18n:Reporte Por Lote',
            resource: 'Control ASC',
            action: 'ver-control-asc-lotes-egresos',
            pageTitle: 'Control Lotes ASC',
            breadcrumb: [
                {
                    text: 'Control ASC',
                    active: true,
                },
                {
                    text: 'Movimientos',
                    active: true,
                },
                {
                    text: 'Egresos',
                },
            ],
        },
    },
    { // Pantalla 4
        path: '/controlAsc/lotes/fresco', // Url Path
        name: 'control-asc-lotes-fresco', // Route name
        component: () => import('@/views/pages/controlAsc/AprobacionLotes.vue'),
        meta: {
			title: 'i18n:ASC',
            resource: 'Control ASC',
            action: 'ver-control-asc-aprobacion-lotes',
            pageTitle: 'Control Lotes ASC',
            breadcrumb: [
                {
                    text: 'Control ASC',
                    active: true,
                },
                {
                    text: 'Aprobacion de lotes Fresco',
                },
            ],
        },
    },
    { // Pantalla 5
        path: '/controlAsc/lotes/valor-agregado', // Url Path
        name: 'control-asc-lotes-va', // Route name
        component: () => import('@/views/pages/controlAsc/AprobacionVA.vue'),
        meta: {
			title: 'i18n:ASC',
            resource: 'Control ASC',
            action: 'ver-control-asc-aprobacion-lotes-va',
            pageTitle: 'Control Lotes ASC',
            breadcrumb: [
                {
                    text: 'Control ASC',
                    active: true,
                },
                {
                    text: 'Aprobacion de lotes de Valor Agregado',
                },
            ],
        },
    },
    { // Pantalla 6
        path: '/controlAsc/lotes/reproceso', // Url Path
        name: 'control-asc-lotes-rp', // Route name
        component: () => import('@/views/pages/controlAsc/AprobacionRP.vue'),
        meta: {
			title: 'i18n:ASC',
            resource: 'Control ASC',
            action: 'ver-control-asc-aprobacion-lotes-rp',
            pageTitle: 'Control Lotes ASC',
            breadcrumb: [
                {
                    text: 'Control ASC',
                    active: true,
                },
                {
                    text: 'Aprobacion de lotes de Reproceso',
                },
            ],
        },
    },
    { // Pantalla 6
        path: '/controlAsc/reportes/por-lotes', // Url Path
        name: 'control-asc-reportes-lotes', // Route name
        component: () => import('@/views/pages/controlAsc/reportes/ReportesPorLote.vue'),
        meta: {
			title: 'i18n:ASC',
            resource: 'Control ASC',
            action: 'ver-control-asc-reportes-saldo-lotes',
            pageTitle: 'Control Lotes ASC',
            breadcrumb: [
                {
                    text: 'Control ASC',
                    active: true,
                },
                {
                    text: 'Reportes por Lotes ASC',
                },
            ],
        },
    },
    { // Pantalla 6
        path: '/controlAsc/reportes/por-items', // Url Path
        name: 'control-asc-reportes-items', // Route name
        component: () => import('@/views/pages/controlAsc/reportes/ReportesPorItems.vue'),
        meta: {
			title: 'i18n:ASC',
            resource: 'Control ASC',
            action: 'ver-control-asc-reportes-saldo-items',
            pageTitle: 'Control Lotes ASC',
            breadcrumb: [
                {
                    text: 'Control ASC',
                    active: true,
                },
                {
                    text: 'Reportes por Items',
                },
            ],
        },
    },
    { // Pantalla 6
        path: '/controlAsc/reportes/embarque', // Url Path
        name: 'control-asc-reportes-embarque-x-tipo', // Route name
        component: () => import('@/views/pages/controlAsc/reportes/ReporteEmbarque.vue'),
        meta: {
			title: 'i18n:ASC',
            resource: 'Control ASC',
            action: 'ver-control-asc-reportes-embarque-x-tipo',
            pageTitle: 'Control Lotes ASC',
            breadcrumb: [
                {
                    text: 'Control ASC',
                    active: true,
                },
                {
                    text: 'Reportes por Embarque',
                },
            ],
        },
    },
    {
        path: '/controlAsc/reportes/embarque-x-lote',
        name: 'control-asc-reportes-embarque-x-lote',
        component: () => import('@/views/pages/controlAsc/reportes/ReporteEmbarqueXLote.vue'),
        meta: {
			title: 'i18n:ASC',
            resource: 'Control ASC',
            action: 'ver-control-asc-reportes-embarque-x-lote',
            pageTitle: 'Reporte Embarque X Lote',
            breadcrumb: [
                {
                    text: 'Control ASC',
                    active: true,
                },
                {
                    text: 'Reportes',
                    active: true,
                },
                {
                    text: 'Reporte Embarque X Lote',
                },
            ],
        },
    },
    { // Pantalla 6
        path: '/controlAsc/reportes/balanceDeMasa', // Url Path
        name: 'control-asc-reportes-balance-masa', // Route name
        component: () => import('@/views/pages/controlAsc/reportes/ReporteBalanceMasa.vue'),
        meta: {
			title: 'i18n:ASC',
            resource: 'Control ASC',
            action: 'ver-control-asc-reportes-balance-masa',
            pageTitle: 'Control Lotes ASC',
            breadcrumb: [
                {
                    text: 'Control ASC',
                    active: true,
                },
                {
                    text: 'Reportes de Balance de Masa',
                },
            ],
        },
    },
    {
        path: '/controlAsc/reportes/recepcion-pesca',
        name: 'control-asc-reporets-recepcion-pesca',
        component: () => import('@/views/pages/controlAsc/reportes/ReporteRecepcionPesca.vue'),
        meta: {
			title: 'i18n:ASC',
            resource: 'Control ASC',
            action: 'ver-control-asc-reportes-recepcion-pesca',
            pageTitle: 'Reporte Recepción de Pesca',
            breadcrumb: [
                {
                    text: 'Control ASC',
                    active: true,
                },
                {
                    text: 'Reportes',
                    active: true,
                },
                {
                    text: 'Reporte Recepción de Pesca',
                },
            ],
        },
    },
    // show a new window

]
